export default "__VITE_ASSET__3hFf4ini__"